import type { ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const userProfileSchemaLiteral = {
  title: 'user_profile',
  version: 0,
  description: 'describes a user profile and its role',
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100, // Supabase UUID
    },
    email: {
      type: 'string',
      maxLength: 150,
    },
    name: {
      type: 'string',
      maxLength: 100,
    },
    job_title: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    role: {
      type: ['string', 'null'],
      maxLength: 50,
    },
    is_owner: {
      type: 'boolean',
      default: false,
    },
    assigned_branches: {
      type: 'array',
      items: {
        type: 'string',
      },
      default: [],
    },
    permissions: {
      type: 'array',
      items: {
        type: 'string',
      },
      default: [],
    },
    created_at: {
      type: 'string',
      maxLength: 50,
    },
    updated_at: {
      type: 'string',
      maxLength: 50,
    },
    is_deleted: {
      type: 'boolean',
      default: false,
    },

    last_modified_by: {
      type: ['string', 'null'],
      maxLength: 100,
    },
  },
  required: ['id', 'email', 'name', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'updated_at'],
} as const;

export type UserProfileDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof userProfileSchemaLiteral>;
export const userProfileSchema = userProfileSchemaLiteral;
